import useReveal from "../hooks/useReveal";
import { company } from "../mock";
import { Check, Phone, Mail, MapPin, Award, ShieldCheck } from "lucide-react";
import logoMark from "../assets/logo-mark.png";

const highlights = [
  "Monivuotinen kokemus sähköenergia-alalla",
  "Käytännön työt 20 kV sähköasemilla",
  "Vahva tuntemus sähkönjakelusta",
  "Käytönjohtajana useissa muuntamoissa",
];

const facts = [
  { icon: Award, value: "2011", label: "Perustettu" },
  { icon: MapPin, value: "Seinäjoki", label: "Toimialue" },
  { icon: ShieldCheck, value: "SETI LK1", label: "Sertifiointi" },
];

export default function About() {
  useReveal();
  return (
    <section
      id="yritys"
      className="relative py-24 lg:py-32 overflow-hidden bg-white"
    >
      {/* Subtle circuit pattern */}
      <div className="absolute inset-0 circuit-bg opacity-40" />

      {/* Floating glowing Selekto logo on light background */}
      <div className="pointer-events-none select-none absolute top-0 right-16 xl:right-48 hidden lg:block">
        <div className="relative logo-float">
          <div className="absolute inset-0 -m-16 rounded-full bg-primary/15 blur-3xl glow-pulse" />
          <img
            src={logoMark}
            alt=""
            aria-hidden="true"
            className="relative h-72 xl:h-96 w-auto drop-shadow-[0_18px_45px_rgba(20,80,180,0.28)]"
          />
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl reveal">
          <span className="text-sm font-semibold tracking-[0.18em] uppercase text-primary">
            Yritys
          </span>
          <h2 className="mt-3 font-extrabold text-3xl sm:text-4xl lg:text-[42px] text-slate-900 leading-tight">
            Selekto Sähköpalvelu
          </h2>
          <p className="mt-5 text-slate-600 text-[17px] leading-relaxed">
            SELEKTO on {company.founded} perustettu sähköpalvelualan yritys
            ({company.anniversary}). Monivuotinen kokemus sähköenergia-alalla on
            luonut vankan pohjan yrittämiseen. Käytännön työt 20 kV
            sähköasematöissä ja tuntemus sähkönjakelusta antavat valmiudet
            vaativiinkin kohteisiin.
          </p>
          <p className="mt-4 text-slate-600 text-[16px] leading-relaxed">
            Toimialueena {company.region} – työkohtaisesti myös kauemmaksi.
            Palveluihin kuuluu lämpökuvaus, sähköön liittyvät mittaukset ja
            kartoitukset sekä huoltoon liittyvät asennus-, osavaihto- ja
            korjaustyöt. Toimimme käytönjohtajana useissa muuntamoissa ja
            vastaamme asiakkaan sähköjärjestelmän turvallisuudesta ja
            velvoitteista.
          </p>
        </div>

        {/* Quick facts */}
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl reveal">
          {facts.map((f) => {
            const Icon = f.icon;
            return (
              <div
                key={f.label}
                className="rounded-xl bg-secondary/50 border border-border p-5 flex items-center gap-4"
              >
                <span className="grid place-items-center w-11 h-11 rounded-lg bg-primary text-white shrink-0">
                  <Icon className="w-5 h-5" />
                </span>
                <div>
                  <div className="font-[Sora] font-extrabold text-lg text-slate-900 leading-none">
                    {f.value}
                  </div>
                  <div className="text-xs text-slate-500 mt-1">{f.label}</div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-8 grid lg:grid-cols-2 gap-6 items-start">
          {/* Contact person card */}
          <div className="reveal rounded-2xl bg-primary text-white p-7 shadow-xl shadow-primary/20">
            <div className="text-xs uppercase tracking-wider text-sky-200 font-semibold">
              Yhteyshenkilö
            </div>
            <div className="mt-2 font-bold text-xl">
              {company.contactPerson.name}
            </div>
            <div className="text-sm text-sky-100/90">
              {company.contactPerson.title}
            </div>
            <div className="mt-5 flex flex-col sm:flex-row gap-4 text-sm">
              <a
                href={`tel:${company.phoneRaw}`}
                className="inline-flex items-center gap-2 text-white hover:text-sky-200 transition-colors"
              >
                <Phone className="w-4 h-4" />
                {company.phone}
              </a>
              <a
                href={`mailto:${company.email}`}
                className="inline-flex items-center gap-2 text-white hover:text-sky-200 transition-colors"
              >
                <Mail className="w-4 h-4" />
                {company.email}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
